// Programme-CATALOG subject groups (programme_subjects, serialized rows) —
// the Banks-tab flavor: subject-group rows carry `children_attributes`,
// rendered as optgroups. Option value is the CHILD programme_subject id
// (catalog namespace — backs `by_programme_subject_id`). NO should_serialize:
// `children_attributes` exists only on serializer rows — the light wire
// returns childless group rows and every optgroup collapses to "No data"
// (v3's hook spreads the caller's `filters` over its own, so its wire never
// actually carried should_serialize). Distinct from useSubjectGroupSelect,
// which is the org-instance flavor (subjects.id). v3 useProgrammeSubjectSelect
// parity, library-modal filter set.
import { useList } from '@refinedev/core';
import { useMemo } from 'react';

import type { APMultiSelectOptionGroup } from '@/components/ap/form';
import { attrs, type JsonApiRow } from './jsonApi';

export const useProgrammeSubjectSelect = (
  programmeId: number | string | null | undefined,
  { enabled = true }: { enabled?: boolean } = {}
) => {
  const { data, isLoading } = useList({
    resource: 'programme_subjects',
    filters: [
      { field: 'by_type_c', operator: 'eq', value: 'group' },
      { field: 'by_programme_id', operator: 'eq', value: programmeId },
      { field: 'unarchived', operator: 'eq', value: true },
    ],
    pagination: { pageSize: 25 },
    queryOptions: { enabled: enabled && programmeId !== null && programmeId !== undefined },
  });

  const groups = useMemo<APMultiSelectOptionGroup[]>(
    () =>
      (data?.data ?? [])
        .map((row: JsonApiRow) => {
          const item = attrs(row);
          const children: any[] = item.children_attributes ?? [];
          return {
            label: String(item.name ?? ''),
            options: children.map((child) => ({
              value: child.id as number,
              label: String(child.name ?? child.id),
            })),
          };
        })
        .filter((group) => group.options.length > 0),
    [data?.data]
  );

  return { groups, isLoading };
};
